module.exports = __webpack_public_path__ + "img/cainiao.dbbf8810.png";